import { render, staticRenderFns } from "./UserBracketsContructor.vue?vue&type=template&id=4f43ec63&scoped=true&"
import script from "./UserBracketsContructor.vue?vue&type=script&lang=js&"
export * from "./UserBracketsContructor.vue?vue&type=script&lang=js&"
import style1 from "./UserBracketsContructor.vue?vue&type=style&index=1&id=4f43ec63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f43ec63",
  null
  
)

export default component.exports